import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, Receipt, UserCircle, LogOut, ShieldCheck, FileText, MessageSquare, CreditCard } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/customer", icon: LayoutDashboard, label: "Overview", end: true, testid: "cnav-overview" },
  { to: "/customer/transactions", icon: Receipt, label: "Transactions", testid: "cnav-transactions" },
  { to: "/customer/mandates", icon: CreditCard, label: "My Mandates", testid: "cnav-mandates" },
  { to: "/customer/statement", icon: FileText, label: "Statement", testid: "cnav-statement" },
  { to: "/customer/feedback", icon: MessageSquare, label: "Feedback", testid: "cnav-feedback" },
  { to: "/customer/profile", icon: UserCircle, label: "Profile", testid: "cnav-profile" },
];

export default function CustomerLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="relative min-h-screen">
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10 py-8">
        <header className="flex items-center justify-between">
          <Logo size={44} />
          <div className="flex items-center gap-3">
            {(user?.role === "admin" || user?.role === "staff") && (
              <NavLink to="/dashboard" className="text-xs uppercase tracking-[0.2em] px-3 py-2 rounded border border-white/10 hover:border-[#fbce18]/40 inline-flex items-center gap-2" data-testid="customer-goto-admin">
                <ShieldCheck size={14} /> Admin
              </NavLink>
            )}
            <button onClick={logout} data-testid="customer-logout-btn" className="text-xs uppercase tracking-[0.2em] px-3 py-2 rounded border border-white/10 hover:border-[#fbce18]/40 inline-flex items-center gap-2">
              <LogOut size={14} /> Sign out
            </button>
          </div>
        </header>

        <nav className="mt-8 flex flex-wrap gap-2">
          {NAV.map((i) => (
            <NavLink
              key={i.to}
              to={i.to}
              end={i.end}
              data-testid={i.testid}
              className={({ isActive }) => `inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs uppercase tracking-[0.2em] border transition-colors ${isActive ? "bg-[#fbce18] text-black border-[#fbce18]" : "border-white/10 text-white/60 hover:text-white hover:border-[#fbce18]/40"}`}
            >
              <i.icon size={14} /> {i.label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
